module.exports = __webpack_public_path__ + "media/gallery/photo04-cda68b74.webp";